
import { UserRegistration, HEADERS } from "../pages/api";
import axios from 'axios';
export default async function RegisterService(combinedData) {
    try {
        const response = await axios.post(
            UserRegistration,
            combinedData,
            { headers: HEADERS }
        );
        return response.data;
    } catch (error) {
        console.error('Error:', error.message);
        throw new Error('Failed to fetch data');
    }

}

